export const TASK_LAST_TOUCH = 'TASK_LAST_TOUCH' as const;
export const TASK_LAST_ENGAGEMENT = 'TASK_LAST_ENGAGEMENT' as const;
export const ACTIVITY_TYPES = 'ACTIVITY_TYPES' as const;
export const ADS = 'ADS' as const;
export const ADS_ACCOUNTS = 'ADS_ACCOUNTS' as const;
export const ADS_ADGROUPS = 'ADS_ADGROUPS' as const;
export const ADS_CAMPAIGNS = 'ADS_CAMPAIGNS' as const;
export const ADS_KEYWORDS = 'ADS_KEYWORDS' as const;
export const ADS_FACEBOOK_ADGROUPS = 'ADS_FACEBOOK_ADGROUPS' as const;
export const ADS_FACEBOOK_ADS = 'ADS_FACEBOOK_ADS' as const;
export const ADS_FACEBOOK_CAMPAIGNS = 'ADS_FACEBOOK_CAMPAIGNS' as const;
export const ADS_GOOGLE_ADGROUPS = 'ADS_GOOGLE_ADGROUPS' as const;
export const ADS_GOOGLE_ADS = 'ADS_GOOGLE_ADS' as const;
export const ADS_GOOGLE_CAMPAIGNS = 'ADS_GOOGLE_CAMPAIGNS' as const;
export const ADS_GOOGLE_KEYWORDS = 'ADS_GOOGLE_KEYWORDS' as const;
export const ADS_LINKEDIN_ADGROUPS = 'ADS_LINKEDIN_ADGROUPS' as const;
export const ADS_LINKEDIN_ADS = 'ADS_LINKEDIN_ADS' as const;
export const ADS_LINKEDIN_CAMPAIGNS = 'ADS_LINKEDIN_CAMPAIGNS' as const;
export const ADS_PROPERTIES = 'ADS_PROPERTIES' as const;
export const ADS_TIKTOK_ADGROUPS = 'ADS_TIKTOK_ADGROUPS' as const;
export const ADS_TIKTOK_ADS = 'ADS_TIKTOK_ADS' as const;
export const ADS_TIKTOK_CAMPAIGNS = 'ADS_TIKTOK_CAMPAIGNS' as const;
export const ALL_OBJECT_PROPERTIES = 'ALL_OBJECT_PROPERTIES' as const;
export const ALL_WORKFLOWS = 'ALL_WORKFLOWS' as const;
export const ANALYTICS_VIEWS = 'ANALYTICS_VIEWS' as const;
export const APP_USERS = 'APP_USERS' as const;
export const AUTOMATED_EMAILS = 'AUTOMATED_EMAILS' as const;
export const AUTOMATION_PLATFORM_WORKFLOWS =
  'AUTOMATION_PLATFORM_WORKFLOWS' as const;
export const BLOG_AUTHOR = 'BLOG_AUTHOR' as const;
export const BLOG_POSTS = 'BLOG_POSTS' as const;
export const BLOG_TAG = 'BLOG_TAG' as const;
export const BLOGS = 'BLOGS' as const;
export const BROADCASTS = 'BROADCASTS' as const;
export const BUSINESS_UNITS = 'BUSINESS_UNITS' as const;
export const BUSINESS_UNIT_DROPDOWN = 'BUSINESS_UNIT_DROPDOWN' as const;
export const CALL_DISPOSITIONS = 'CALL_DISPOSITIONS' as const;
export const CAMPAIGNS = 'CAMPAIGNS' as const;
export const CHATFLOW = 'CHATFLOW' as const;
export const CHATFLOWS_BY_UNIQUE_ID = 'CHATFLOWS_BY_UNIQUE_ID' as const;
export const COMMENTS = 'COMMENTS' as const;
export const COMPANIES = 'COMPANIES' as const;
export const COMPANIES_SAVED_FILTERS = 'COMPANIES_SAVED_FILTERS' as const;
export const COMPANY_PROPERTIES = 'COMPANY_PROPERTIES' as const;
export const CONTACT_LISTS = 'CONTACT_LISTS' as const;
export const CONTACT_PROPERTIES = 'CONTACT_PROPERTIES' as const;
export const CONTACT_STATIC_LISTS = 'CONTACT_STATIC_LISTS' as const;
export const CONTACTS = 'CONTACTS' as const;
export const CONTACTS_BY_EMAIL = 'CONTACTS_BY_EMAIL' as const;
export const CONTENTS = 'CONTENTS' as const;
export const CONTACTS_SAVED_FILTERS = 'CONTACTS_SAVED_FILTERS' as const;
export const CONVERSATION_INBOX = 'CONVERSATION_INBOX' as const;
export const CONVERSATION_PROPERTIES = 'CONVERSATION_PROPERTIES' as const;
export const COS_INDEX_CONNECTIONS_PARENTS =
  'COS_INDEX_CONNECTIONS_PARENTS' as const;
export const CTA_TO_PLACEMENT = 'CTA_TO_PLACEMENT' as const;
export const CTAS = 'CTAS' as const;
export const CTA_GUID = 'CTA_GUID' as const;
export const CUSTOM_OBJECT = 'CUSTOM_OBJECT' as const;
export const CUSTOM_OBJECT_TYPES = 'CUSTOM_OBJECT_TYPES' as const;
export const DEAL_PIPELINE_STAGES = 'DEAL_PIPELINE_STAGES' as const;
export const DEAL_PIPELINES = 'DEAL_PIPELINES' as const;
export const DEAL_PROPERTIES = 'DEAL_PROPERTIES' as const;
export const DEALS = 'DEALS' as const;
export const REVENUE_DEAL_MERGES = 'REVENUE_DEAL_MERGES' as const;
export const DEALS_SAVED_FILTERS = 'DEALS_SAVED_FILTERS' as const;
export const ECOMMERCE_APPS = 'ECOMMERCE_APPS' as const;
export const ECOMMERCE_STORES = 'ECOMMERCE_STORES' as const;
export const EDITABLE_DEALS = 'EDITABLE_DEALS' as const;
export const EMAIL_CAMPAIGN_URLS = 'EMAIL_CAMPAIGN_URLS' as const;
export const EMAIL_CAMPAIGNS = 'EMAIL_CAMPAIGNS' as const;
export const EMAIL_SUBSCRIPTION_GROUPS = 'EMAIL_SUBSCRIPTION_GROUPS' as const;
export const EMAIL_SUBSCRIPTIONS = 'EMAIL_SUBSCRIPTIONS' as const;
export const SMS_SUBSCRIPTIONS = 'SMS_SUBSCRIPTIONS' as const;
export const WHATSAPP_SUBSCRIPTIONS = 'WHATSAPP_SUBSCRIPTIONS' as const;
export const EMAIL_VALIDATION = 'EMAIL_VALIDATION' as const;
export const EMAILS = 'EMAILS' as const;
export const ENGAGEMENT_PROPERTIES = 'ENGAGEMENT_PROPERTIES' as const;
export const ENGAGEMENTS = 'ENGAGEMENTS' as const;
export const EVENTS = 'EVENTS' as const;
export const FEEDBACK = 'FEEDBACK' as const;
export const FEEDBACK_FORMS = 'FEEDBACK_FORMS' as const;
export const FORMS = 'FORMS' as const;
export const HIERARCHICAL_TEAMS = 'HIERARCHICAL_TEAMS' as const;
export const HIERARCHICAL_TEAMS_BY_USER = 'HIERARCHICAL_TEAMS_BY_USER' as const;
export const IMPORT_NAMES = 'IMPORT_NAMES' as const;
export const INBOUND_DB_COMPANY_IMPORT = 'INBOUND_DB_COMPANY_IMPORT' as const;
export const INBOUND_DB_COMPANY_LIST = 'INBOUND_DB_COMPANY_LIST' as const;
export const INBOUND_DB_CONTACT_IMPORT = 'INBOUND_DB_CONTACT_IMPORT' as const;
export const INBOUND_DB_CONTACT_LIST = 'INBOUND_DB_CONTACT_LIST' as const;
export const INBOUND_DB_DEAL_IMPORT = 'INBOUND_DB_DEAL_IMPORT' as const;
export const INBOUND_DB_DEAL_LIST = 'INBOUND_DB_DEAL_LIST' as const;
export const INBOUND_DB_IMPORT = 'INBOUND_DB_IMPORT' as const;
export const INBOUND_DB_LISTS = 'INBOUND_DB_LISTS' as const;
export const INBOUND_DB_TASK_IMPORT = 'INBOUND_DB_TASK_IMPORT' as const;
export const INBOUND_DB_TICKET_LIST = 'INBOUND_DB_TICKET_LIST' as const;
export const INBOUND_SMS_KEYWORD = 'INBOUND_SMS_KEYWORD' as const;
export const INTEGRATION_NAMES = 'INTEGRATION_NAMES' as const;
export const INTEGRATION_PROPERTIES = 'INTEGRATION_PROPERTIES' as const;
export const INTEGRATIONS = 'INTEGRATIONS' as const;
export const INVOICE_PROPERTIES = 'INVOICE_PROPERTIES' as const;
export const KNOWLEDGE_ARTICLES = 'KNOWLEDGE_ARTICLES' as const;
export const LANDING_PAGES = 'LANDING_PAGES' as const;
export const LEAD_FLOWS = 'LEAD_FLOWS' as const;
export const LINE_ITEM_PROPERTIES = 'LINE_ITEM_PROPERTIES' as const;
export const LINE_ITEMS = 'LINE_ITEMS' as const;
export const MARKETING_EVENT = 'MARKETING_EVENT' as const;
export const MEETING_OUTCOME = 'MEETING_OUTCOME' as const;
export const MARKETING_REASONS = 'MARKETING_REASONS' as const;
export const MARKETING_EVENT_APP_NAMES = 'MARKETING_EVENT_APP_NAMES' as const;
export const MULTI_CURRENCY_CURRENCY_CODES =
  'MULTI_CURRENCY_CURRENCY_CODES' as const;
export const MULTI_CURRENCY_INFORMATION = 'MULTI_CURRENCY_INFORMATION' as const;
export const OBJECT_PROPERTIES = 'OBJECT_PROPERTIES' as const;
export const OBJECT_COORDINATES = 'OBJECT_COORDINATES' as const;
export const OWNERS = 'OWNERS' as const;
export const PERSONAS = 'PERSONAS' as const;
export const PIPELINES = 'PIPELINES' as const;
export const PRODUCT_FOLDERS = 'PRODUCT_FOLDERS' as const;
export const PRODUCT_PROPERTIES = 'PRODUCT_PROPERTIES' as const;
export const PRODUCTS = 'PRODUCTS' as const;
export const PROPERTY_GROUPS = 'PROPERTY_GROUPS' as const;
export const QUOTE_PROPERTIES = 'QUOTE_PROPERTIES' as const;
export const QUOTES = 'QUOTES' as const;
export const QUOTE_TEMPLATES = 'QUOTE_TEMPLATES' as const;
export const SALESFORCE_CAMPAIGNS = 'SALESFORCE_CAMPAIGNS' as const;
export const SEQUENCES = 'SEQUENCES' as const;
export const SEQUENCES_WITH_PERMISSIONS = 'SEQUENCES_WITH_PERMISSIONS' as const;
export const SEQUENCE_STEP_ORDER = 'SEQUENCE_STEP_ORDER' as const;
export const SHARED_TASK_QUEUES = 'SHARED_TASK_QUEUES' as const;
export const SITE_CONTENT = 'SITE_CONTENT' as const;
export const SITE_PAGES = 'SITE_PAGES' as const;
export const SLACK_CHANNEL = 'SLACK_CHANNEL' as const;
export const SLACK_USER = 'SLACK_USER' as const;
export const SUBDOMAIN_IDS = 'SUBDOMAIN_IDS' as const;
export const SOCIAL_CHANNEL = 'SOCIAL_CHANNEL' as const;
export const SUBDOMAINS = 'SUBDOMAINS' as const;
export const SUBSCRIPTIONS = 'SUBSCRIPTIONS' as const;
export const SUBMISSION_TAG = 'SUBMISSION_TAG' as const;
export const SURVEY_QUESTIONS = 'SURVEY_QUESTIONS' as const;
export const SURVEY_SETTINGS = 'SURVEY_SETTINGS' as const;
export const SURVEYS = 'SURVEYS' as const;
export const EXTERNAL_ACCOUNTS = 'EXTERNAL_ACCOUNTS' as const;
export const TASK_QUEUES = 'TASK_QUEUES' as const;
export const TASKS = 'TASKS' as const;
export const TEAMS = 'TEAMS' as const;
export const TEMPLATES = 'TEMPLATES' as const;
export const TICKET_PIPELINES = 'TICKET_PIPELINES' as const;
export const TICKET_PROPERTIES = 'TICKET_PROPERTIES' as const;
export const TICKETS = 'TICKETS' as const;
export const USERS = 'USERS' as const;
export const WEBINAR_SETTINGS = 'WEBINAR_SETTINGS' as const;
export const WEBINARS = 'WEBINARS' as const;
export const WEB_INTERACTIVES = 'WEB_INTERACTIVES' as const;
export const WORKFLOWS = 'WORKFLOWS' as const;
export const WORKFLOW_FOLDERS = 'WORKFLOW_FOLDERS' as const;
export const WORKFLOWS_SALESFORCE = 'WORKFLOWS_SALESFORCE' as const;
